import { RegulatoryInformationModel } from "./types";

export const isNoMoreInfoNeededCaseTrue = (
  companyClassification: RegulatoryInformationModel["companyClassification"],
): boolean =>
  companyClassification === "LISTED_COMPANY_OR_SUBSIDIARY_MAJORITY" ||
  companyClassification === "AUTHORITY_OR_NON_PROFIT" ||
  companyClassification === "UNREGISTERED_PARTNERSHIP" ||
  companyClassification === "BANK_OR_ANOTHER_FINANCIAL_INTERMEDIARY" ||
  companyClassification === "NON_OPERATING_FOUNDATION";

export const isCompanyClassificationBeneficialOwnerCase = (
  companyClassification: RegulatoryInformationModel["companyClassification"],
  isSoleProprietorship: boolean,
): boolean =>
  companyClassification === "NON_OPERATIONAL_COMPANY" || isSoleProprietorship;

export const isCompanyClassificationControllingOwnersCase = (
  companyClassification: RegulatoryInformationModel["companyClassification"],
): boolean => companyClassification === "NONE_OF_THE_AVAILABLE_CLASSIFICATIONS";
